export default "__VITE_ASSET__DOmyCqII__"